import api, { apiInternal, multiPartHeader, partHeader } from '../api';

const pathMusic = 'music';

export async function getArtists() {
  const { data } = await api.post(`${apiInternal}/${pathMusic}/artist/list`, { }, partHeader);  
  return data;
}

export async function getAlbums(art_id) {
  const { data } = await api.post(`${apiInternal}/${pathMusic}/album/list`, { art_id }, partHeader);  
  return data;
}
export async function getGenres(){
 const { data } = await api.post(`${apiInternal}/${pathMusic}/genre`, { },partHeader);  
  return data;
  
}

export async function setArtist(artist) {
  const {data} = await api.post(`${apiInternal}/${pathMusic}/artist/set`, { art_id: artist.art_id, art_name: artist.art_name, art_description: artist.art_description },partHeader);
  return data;
}
export async function getTracks(alb_id) {
  const {data} = await api.post(`${apiInternal}/${pathMusic}/track/list`, { alb_id } , partHeader);
  return data;
}

export async function getAsset( ass_id, source) {
  const ids = [];
  ids.push(ass_id);
  const {data} = await api.post(`${apiInternal}/${pathMusic}/asset`, { ids, source, format: 'b64'}, partHeader );
  return data;
}

export async function setAlbum(art_id, album){
  const value = {
    art_id,
    alb_id: album.alb_id,
    alb_name: album.alb_name,
    alb_description: album.alb_description || '',
    alb_year: album.alb_year?.length > 0 ? Number(album.alb_year) : 1970,
    genres: album.genres
  }
  const {data} = await api.post(`${apiInternal}/${pathMusic}/album/set`, value, partHeader);
  return data;  
}

export async function setTrack(alb_id, track){
  const value = {
    alb_id,
    trk_id: track.trk_id,
    trk_number: track.trk_number,
    trk_name: track.trk_name,
    trk_description: track.trk_description || '',
    trk_year: track.trk_year?.length > 0 ? Number(track.trk_year) : null, 
    trk_gmus_id: track.trk_gmus_id, 
    trk_duration: track.trk_duration
  }
  const {data} = await api.post(`${apiInternal}/${pathMusic}/track/set`, value, partHeader);
  return data;  
}

export async function setAsset(id, context, file, filename){
  const formData = new FormData();
  formData.append('file', file);
  formData.append('contextId', id);
  formData.append('context', context);
  formData.append('filename', filename);

  const {data} = await api.post(`${apiInternal}/${pathMusic}/setAsset`, formData, partHeader);
  return data;  

}

export async function setMusicFile(id, file, filename){
  const formData = new FormData();
  formData.append('file', file);
  formData.append('trk_id', id);
  formData.append('filename', filename);

  const {data} = await api.post(`${apiInternal}/${pathMusic}/track/UploadfileMusic`, formData, partHeader);
  return data;  
  
}